module.exports = __webpack_public_path__ + "static/media/saw.907810ba.png";